var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 12.223"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon/Dropdown"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Icon/Dropdown background",
  fill: "rgba(0,0,0,0)",
  d: "M16 0v12.223H0V0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "ICon/Dropdown",
  d: "m10.049 12.223.951-.951-5.161-5.161L11 .951 10.049 0l-5.16 5.161-.951.951.951.951Z",
  fill: "currentColor"
}))));
export default SvgLeftArrow;